import {
  Dialog as DialogMui,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Box,
  Slide,
  Fade,
  useMediaQuery,
} from '@mui/material';
import {TransitionProps} from '@mui/material/transitions';
import React from 'react';
import {media} from '@/styles/mediaQueries';
import {ModalProps} from './ModalProps';
import styles from './style';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {children: React.ReactElement},
  ref: React.Ref<unknown>
) {
  const isMobile = useMediaQuery(media.mobile.replace('@media ', ''));
  return isMobile ? (
    <Slide direction="up" ref={ref} {...props} />
  ) : (
    <Fade ref={ref} {...props} />
  );
});

const StyledDialog = styled(DialogMui, {
  shouldForwardProp: (prop) => prop !== 'bottomSheet',
})<{bottomSheet?: boolean}>(({bottomSheet}) => ({
  '.MuiPaper-root': {
    width: '700px',
    overflow: 'hidden',
    [media.mobile]: {
      margin: '0px',
      alignSelf: 'end',
      maxHeight: 'calc(100% - 53px)',
      borderRadius: '10px',
      // !important overrides MUI's elevation-24 downward shadow so the sheet's top shadow shows.
      ...(bottomSheet && {
        width: '100%',
        borderRadius: '20px 20px 0 0',
        boxShadow: '0 -6px 24px rgba(20, 20, 40, 0.2) !important',
      }),
    },
  },
}));

const StyledDialogContent = styled(DialogContent)({
  width: '672px',
  padding: '0px 28px',
  [media.mobile]: {
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: '#FCFCFD',
  },
});

const StyledContentContainer = styled(Box)({
  margin: 0,
  fontFamily: 'Brown LL',
  fontWeight: 400,
  fontSize: '1rem',
  lineHeight: '1.5',
  color: 'rgba(0, 0, 0, 0.6)',
  width: '647px',
  [media.mobile]: {
    width: '100%',
  },
});

function Modal(props: ModalProps) {
  const {
    dividers,
    title,
    actions,
    onClose,
    open,
    children,
    bottomSheet,
    ...rest
  } = props;

  return (
    <StyledDialog
      {...rest}
      open={open}
      onClose={onClose}
      bottomSheet={bottomSheet}
      {...(bottomSheet ? {TransitionComponent: Transition} : {})}
    >
      {title && <DialogTitle style={styles.DialogTitle}>{title}</DialogTitle>}
      <StyledDialogContent dividers={dividers}>
        <StyledContentContainer>{children}</StyledContentContainer>
      </StyledDialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </StyledDialog>
  );
}

export default Modal;
